<template>
  <div>
    <div class="ivu-dropdown">
      <div class="ivu-dropdown-rel" @click.stop="clickCollapse">
        <a class="sideBarMenuShrink-item">
          <i class="ivu-icon ivu-icon-ios-options" style="font-size: 20px;"></i>
        </a>
      </div>
    </div>
    <Dropdown
      v-for="menuItem in menuLists"
      transfer
      placement="right-start"
      :key="menuItem.name"
      @on-click="changeMenu"
    >
      <a class="sideBarMenuShrink-item">
        <Icon :size="20" :type="menuItem.icon"></Icon>
      </a>
      <DropdownMenu style="width: 200px;" slot="list">
        <DropdownItem
          v-for="subMenuItem in menuItem.children"
          :name="subMenuItem.name"
          :key="subMenuItem.name"
        >
          <Icon :type="subMenuItem.icon"></Icon>
          <span style="padding-left:10px;">{{subMenuItem.title}}</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
export default {
  props: {
    menuLists: {
      type: Array,
    },
  },

  methods: {
    changeMenu(name) {
      this.$router.push({ name })
    },
    clickCollapse () {
      this.$emit('changeZK', true);
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar-menu/sidebar-menu-shrink.vue